import request from '@/utils/request'

// ==================== 设备管理 ====================

export const getDeviceList = (params: { pageNum: number; pageSize: number; workshopId?: number; online?: number }) => {
  return request<any>({ method: 'GET', url: '/devices', params })
}

export const getDeviceDetail = (deviceId: string) => {
  return request<any>({ method: 'GET', url: `/devices/${deviceId}` })
}

export const createDevice = (data: any) => {
  return request<string>({ method: 'POST', url: '/devices', data })
}

export const updateDevice = (id: number, data: any) => {
  return request<string>({ method: 'PUT', url: `/devices/${id}`, data })
}

export const deleteDevice = (id: number) => {
  return request<string>({ method: 'DELETE', url: `/devices/${id}` })
}

export const getBatchRealtime = () => {
  return request<any[]>({ method: 'GET', url: '/devices/realtime/batch' })
}

export const getStatisticsOverview = () => {
  return request<any>({ method: 'GET', url: '/devices/statistics/overview' })
}

// v2.5：数据大屏中国地图
export const getProvinceDistribution = () => {
  return request<any[]>({ method: 'GET', url: '/devices/province-distribution' })
}

export const getMapMarkers = () => {
  return request<any[]>({ method: 'GET', url: '/devices/map-markers' })
}

// v2.5：数据大屏 12 个月用电趋势
export const getMonthlyEnergy = (months: number = 12) => {
  return request<any[]>({ method: 'GET', url: '/device-data/monthly-energy', params: { months } })
}

// ==================== 车间管理 ====================

export const getWorkshopList = () => {
  return request<any[]>({ method: 'GET', url: '/devices/workshops' })
}

export const createWorkshop = (data: any) => {
  return request<string>({ method: 'POST', url: '/devices/workshops', data })
}

export const updateWorkshop = (id: number, data: any) => {
  return request<string>({ method: 'PUT', url: `/devices/workshops/${id}`, data })
}

export const deleteWorkshop = (id: number) => {
  return request<string>({ method: 'DELETE', url: `/devices/workshops/${id}` })
}

// ==================== 实时数据 ====================

export const getRealtimeData = (deviceId: string) => {
  return request<any>({ method: 'GET', url: `/device-data/${deviceId}/realtime` })
}

export const getDeviceConfig = (deviceId: string) => {
  return request<any>({ method: 'GET', url: `/device-data/${deviceId}/config` })
}

export const updateDeviceConfig = (deviceId: string, data: any) => {
  return request<string>({ method: 'PUT', url: `/device-data/${deviceId}/config`, data })
}

// ==================== 远程命令 ====================

export const sendSetPID = (deviceId: string, data: { sid: number; p: number; i: number; d: number; atMode?: number; p_md?: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setPID`, data })
}

export const sendSetAlarm = (deviceId: string, data: { sid: number; almHigh: number; almLow: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setAlarm`, data })
}

export const sendSetTimer = (deviceId: string, data: any) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setTimer`, data })
}

export const sendSetWorkMode = (deviceId: string, data: { mode: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setWorkMode`, data })
}

// v2.5 新增：拆分自 setWorkMode
// triggerMode: 0=手动启动, 1=定时启动; sid: 0=多段全局, 1~4=单段per-TC
export const sendSetTriggerMode = (deviceId: string, data: { sid?: number; mode: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setTriggerMode`, data })
}

// heatMode: 0=停止, 1=单段加热, 2=多段加热（互斥）
export const sendSetHeatMode = (deviceId: string, data: { mode: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setHeatMode`, data })
}

// 单段加热启停 + 设 SV
export const sendSetSingleHeat = (deviceId: string, data: { sid: number; sv?: number; action: 'start' | 'stop' }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setSingleHeat`, data })
}

// 单段加热每 TC 4 个定时（HH:mm 字符串数组，空串=禁用）
export const sendSetSingleTimer = (deviceId: string, data: { sid: number; periodStart: string[] }) => {
  const payload: Record<string, any> = { sid: data.sid }
  data.periodStart.forEach((p, i) => { payload[`periodStart_${i}`] = p })
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setSingleTimer`, data: payload })
}

export const sendSetFreq = (deviceId: string, data: { sid: number; freq: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setFreq`, data })
}

export const sendSetVFD = (deviceId: string, data: { sid: number; action: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setVFD`, data })
}

export const sendSetReboot = (deviceId: string) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setReboot` })
}

export const sendGetAllParameter = (deviceId: string) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/getAllParameter` })
}

export const sendGetProgram = (deviceId: string, data: { sid: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/getProgram`, data })
}

export const sendSetProgram = (deviceId: string, data: { sid: number; segments: Array<{ seg: number; sv: number; sv2?: number; hold: number }> }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setProgram`, data })
}

export const sendSetIpPort = (deviceId: string, data: { URL: string; port: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setipport`, data })
}

export const sendSetTimeLog = (deviceId: string, data: { uploadperiod: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setTimeLog`, data })
}

export const sendSetPowerRetention = (deviceId: string, data: { enable: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setPowerRetention`, data })
}

export const sendSetDeviceName = (deviceId: string, data: { deviceName: string }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setDeviceName`, data })
}

export const sendSetUpgrade = (deviceId: string) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setUpgrade` })
}

// v2.6 新增：RN7302 电能标定参数读写 + 整机锁定
export const sendSetPowerMeterParam = (deviceId: string, data: {
  ovThreshold?: number; uvThreshold?: number; ocThreshold?: number
  extCtRatio?: number; vRmsConst?: number; iRmsConst?: number
  iOffset?: number; pRmsConst?: number; hfconst?: number
}) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setPowerMeterParam`, data })
}

export const sendGetPowerMeterParam = (deviceId: string) => {
  return request<any>({ method: 'POST', url: `/device-data/${deviceId}/command/getPowerMeterParam` })
}

export const sendSetDeviceLock = (deviceId: string, data: { lock: number }) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/setDeviceLock`, data })
}

export const sendClearEditPassword = (deviceId: string) => {
  return request<string>({ method: 'POST', url: `/device-data/${deviceId}/command/clearEditPassword` })
}

// ==================== 历史数据（TDengine） ====================

export const getTemperatureCurve = (deviceId: string, params: { sid: number; range: string }) => {
  return request<any[]>({ method: 'GET', url: `/device-data/${deviceId}/temperature`, params })
}

export const getPowerHistory = (deviceId: string, params: { range: string }) => {
  return request<any[]>({ method: 'GET', url: `/device-data/${deviceId}/power`, params })
}

export const getEnergyStats = (deviceId: string, params: { range: string }) => {
  return request<any>({ method: 'GET', url: `/device-data/${deviceId}/energy`, params })
}

export const getUploadHistory = (deviceId: string, params: { range: string; page: number; size: number }) => {
  return request<any>({ method: 'GET', url: `/device-data/${deviceId}/upload-history`, params })
}

// ==================== 操作日志 ====================

export const getOperationLogList = (params: { pageNum: number; pageSize: number; module?: string; startTime?: string; endTime?: string }) => {
  return request<any>({ method: 'GET', url: '/operation-log', params })
}

// ==================== 报警管理 ====================

export const getAlarmList = (params: { pageNum: number; pageSize: number; deviceId?: string; severity?: string; status?: number }) => {
  return request<any>({ method: 'GET', url: '/alarms', params })
}

export const getAlarmStatistics = () => {
  return request<any>({ method: 'GET', url: '/alarms/statistics' })
}

export const confirmAlarm = (id: number) => {
  return request<string>({ method: 'PUT', url: `/alarms/${id}/confirm` })
}

export const batchConfirmAlarms = (ids: number[]) => {
  return request<string>({ method: 'PUT', url: '/alarms/batch-confirm', data: { ids } })
}

export const clearAlarms = () => {
  return request<string>({ method: 'DELETE', url: '/alarms/clear' })
}

// ==================== 段程序 ====================

export const getProgramList = (deviceId: string) => {
  return request<any[]>({ method: 'GET', url: '/programs', params: { deviceId } })
}

export const getProgramDetail = (id: number) => {
  return request<any>({ method: 'GET', url: `/programs/${id}` })
}

export const createProgram = (data: any) => {
  return request<string>({ method: 'POST', url: '/programs', data })
}

export const updateProgram = (id: number, data: any) => {
  return request<string>({ method: 'PUT', url: `/programs/${id}`, data })
}

export const deleteProgram = (id: number) => {
  return request<string>({ method: 'DELETE', url: `/programs/${id}` })
}

export const startProgram = (id: number) => {
  return request<string>({ method: 'POST', url: `/programs/${id}/start` })
}

export const pauseProgram = (id: number) => {
  return request<string>({ method: 'POST', url: `/programs/${id}/pause` })
}

export const stopProgram = (id: number) => {
  return request<string>({ method: 'POST', url: `/programs/${id}/stop` })
}
